"use strict";
import { ServiceWorker } from "./observer/ServiceWorker.js";
import { MSPopUpWindow } from "./controls/popup_window/popup_window.js";
import { WinDefs, Permissions } from "generated";
import { NotifyService } from "./notofiService.js";
import { WindowService } from "./winService.js";
import { PermissionsManager } from "./observer/PermissionsManager.js";
import { StateStorageAdapter } from "./observer/StateStorageAdapter.js";
import { PathResolver } from "./observer/PathResolver.js";
import { TranslateService } from "./services/translateService/translateService.js"
import { toBool, getConvertedValue, ARGBtoObj, objToCSS } from "./lib/utils.js";

/***
 * @global
 * @class mainWorker
 * @classdesc Главный класс
 * */

export class mainWorker {
    constructor() {
        if (!window._globalParams.RedundancyIP) {
            window._globalParams.WebPort = document.location.port;
            window._globalParams.location.port = document.location.port;
            // if (window._globalParams.WebPort == 80) {
            //     window._globalParams.WebPort = 8043;
            //     window._globalParams.location.port = 8043;
            // }
            window._globalParams.location.hostname = document.location.hostname;
            window._globalParams.MainIP = document.location.hostname;
        }

        if (_globalParams.UserColors) {
            _globalParams.UserColors = Object.fromEntries(Object.entries(_globalParams.UserColors).map(([k, v]) => [k.toLowerCase(), v]));
        }

        document.body.parentNode.style.overflow = "hidden";
        window.translateService = new TranslateService();
        window.stack = new Map();
        window.$WinDefs = new WinDefs();
        window.$ns = new NotifyService(window._globalParams.LogLevel, window._globalParams.BrowserLog);
        window.$WinService = new WindowService();
        window.$sw = this.sw = new ServiceWorker();
        window.$pm = this.pm = new PermissionsManager();
        window.$ss = new StateStorageAdapter();
        window.$pr = new PathResolver();
        window.trendLog = [];
        this.windowId = 1;
        

        if(typeof window.structuredClone !== 'function') {
            window.structuredClone = (obj) => JSON.parse(JSON.stringify(obj))
        }

        
        if (window.ipc) {
            this.ipc = window.ipc.get();
            this.ipc.on("client", (event, ...arg) => {
                switch (arg[0]) {
                    case "session":
                        this.sw.sessionId = arg[1].data.sessionId;
                        //this.sw.serverState.UserData = arg[1].userData;
                        //this.sw.serverState.LoginTime = this.serverState.UserData ? this.serverState.UserData.serverTime : 0;
                        //sessionStorage.setItem('serverState.LoginTime', this.serverState.LoginTime);
                        this.start(this.sw.sessionId);
                        break;
                    case "logout":
                        this.logout({
                            sendEvent: false,
                        });
                        break;
                    case "error":
                        $ns.add({
                            type: "error",
                            time: new Date().toLocaleString(),
                            title: arg[1].title,
                            text: arg[1].text,
                        });
                        break;
                }
            });
            if (Permissions.disableOsRights) {
                const collect = Object.keys(Permissions.disableOsRights).map(
                    e => Permissions.disableOsRights[e]
                );
                if (collect.length > 0 && collect.reduce((a, b) => a || b)) {
                    const error = this.ipc.sendSync("server", "WinBlock.CADon");
                }
            } else if (window._globalParams.DisableOSAccessWhileLogin) {
                const error = this.ipc.sendSync("server", "WinBlock.CADon");
            }
        }

        // $ns.add({type:'warning',time: new Date().toLocaleString(),title:'test warning',text:'warning bla bla bla'});
        // $ns.add({type:'error',time: new Date().toLocaleString(),title:'test error',text:'error bla bla bla'});
        // $ns.add({type:'info',time: new Date().toLocaleString(),title:'test info',text:'info bla bla bla'});

        this.popup = document.getElementById("service-popup");

        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams && urlParams.keys().next().value) {
            if ($WinDefs.winDef[Number(urlParams.keys().next().value)]) {
                this.customStatWin = Number(urlParams.keys().next().value);
            }
            this.tUser = urlParams.get("user");
            this.tPass = urlParams.get("password");
            this.tSessionId = urlParams.get("session_id");
            if (this.tSessionId) {
                this.sw.sessionId = this.tSessionId;
                this.start(this.sw.sessionId);
            }
        }

        this._events();
        this._windows = [];
        if (!window._globalParams.OfflineMode) {
            if (this.ipc) {
                this.windowId = this.ipc.sendSync("server", "getId");
                window.$sw.isMainWindow = this.windowId == 1;
                window.savePath = this.ipc.sendSync("server", "getSavePath");
                try {
                    window.saveDeviceDesc = this.ipc.sendSync(
                        "server",
                        "getSaveDeviceDesc"
                    );
                } catch (e) { }
                if (window.saveDeviceDesc == null) window.saveDeviceDesc = "";
                window.PrinterName = this.ipc.sendSync(
                    "server",
                    "getPrinerName"
                );
                window.clientPrinter = this.ipc.sendSync(
                    "server",
                    "ClientPrinter"
                );
                try {
                    window.hostName = this.ipc.sendSync(
                        "server",
                        "getHostName"
                    );
                } catch (e) { }
                if (this.windowId == 1) {
                    this.start();
                }
            } else {
                this.start();
            }
        }
        window.$confirm = this.confirm.bind(this);
        window._allert = this.allert;
        window.onresize = () => {
            if (window.__rootWin) {
                window.__rootWin.scaleRootWindow();
            }
        };

        window.onpopstate = e => {
            if (!this.mainFrameEl)
                this.mainFrameEl = document.querySelector(
                    `[id="${WinDefs.mainFrame[window.activeMonitorTemplateId]}"]`
                );
            if (e.state !== null && e.state.obj) {
                this.mainFrameEl.openWindow(e.state.obj, true);
            }
        };

        document.body.addEventListener("contextmenu", e => {
            if (e.preventDefault != undefined) e.preventDefault();
            if (e.stopPropagation != undefined) e.stopPropagation();
        });
        document.addEventListener("keydown", function (e) {
            if (
                !e.altKey &&
                !e.shiftKey &&
                !e.ctrlKey &&
                e.which === window._enums.ButtonKeyCode.FULL_SCREEN
            ) {
                e.preventDefault();
                if (!window.eRemote) {
                    document.documentElement.requestFullscreen();
                }
            }
            
        });

        document.addEventListener("mouseover", this.toolTipShow.bind(this));
        document.addEventListener("mouseout", this.toolTipHide.bind(this));
    }

    zoom() {
        this.screenOptions = JSON.parse(window._globalParams.ScreensOptions)[window.activeMonitorTemplateId];
        if (this.screenOptions && !toBool(this.screenOptions.DisableScale)) {
            let scale = 1;
            document.body.style.zoom = scale;
            document.body.style.overflow = "auto";
            document.addEventListener(
                "keydown",
                (event) => {
                    if (
                        event.ctrlKey &&
                        (event.key === "=" || event.key === "+" || event.which === 61 || event.which === 107)
                    ) {
                        scale += 0.1;
                    } else if (
                        event.ctrlKey &&
                        (event.key === "-" || event.which === 173 || event.which === 109 || event.which === 189)
                    ) {
                        scale = Math.max(0.1, scale - 0.1);
                    }
    
                    if (
                        event.ctrlKey &&
                        (event.key === "=" || event.key === "+" || event.key === "-" ||
                            event.which === 61 || event.which === 107 ||
                            event.which === 173 || event.which === 109 || event.which === 189)
                    ) {
                        document.body.style.zoom = scale.toFixed(1);
                        event.preventDefault();
                    }
                },
                { passive: false }
            );
    
            document.addEventListener(
                "wheel",
                (event) => {
                    if (event.ctrlKey) {
                        event.preventDefault();
                    }
                },
                { passive: false }
            );
        }
    }

    start(sessionId) {
        const event = new CustomEvent("ms_message");
        event.data = { event: "start" };
        if (typeof sessionId !== "undefined") {
            event.data.sessionId = sessionId;
        }
        window.dispatchEvent(event);
    }

    _events() {
        window.addEventListener("ms_message", message => {
            const data = message.data;
            switch (data.event) {
                case "start":
                    this.setPopupText(`${i18next.t('main_connectionServer')}`);
                    this.wrk = false;
                    const isRelogin =
                        event.data.sessionId != null &&
                        this.sw.ServerAdapter.subscriptionId;

                    if (this.tryStart != null) {
                        console.log(`clear old timer ${this.tryStart}`)
                        clearInterval(this.tryStart);
                        this.tryStart = null;
                    }

                    this.tryStart = setInterval(() => {
                        if (this.wrk) {
                            return;
                        }
                        this.wrk = true;
                        Promise.race([
                            new Promise(reject => setTimeout(reject, 5000)),
                            this.sw.GetState(),
                        ])
                            .then(data => {
                                if (
                                    !data ||
                                    data.code !== 0 ||
                                    (!data.isMaster &&
                                        this.sw.serverState.haveReserv)
                                ) {
                                    this.sw
                                        .Redirect(true)
                                        .then(() =>
                                            this.processGetLoginData(
                                                null,
                                                false
                                            )
                                        )
                                        .catch(err => (this.wrk = false));
                                } else if (
                                    data &&
                                    data.code === 0 &&
                                    (data.isMaster ||
                                        !this.sw.serverState.haveReserv)
                                ) {
                                    this.sw.serverState.currentState = data;
                                    if (
                                        isRelogin &&
                                        document.location.hostname !==
                                        this.sw.serverState.location
                                            .hostname
                                    ) {
                                        $ns.add({
                                            type: "info",
                                            time: new Date().toLocaleString(),
                                            title: `${i18next.t('main_connectionEstablished')}`,
                                            text: String.format(i18next.t("connection_success"), this.sw.serverState.location.hostname),
                                        });
                                    }
                                    this.processGetLoginData(
                                        data.sessionId,
                                        isRelogin
                                    );
                                } else {
                                    this.wrk = false;
                                }
                            })
                            .catch(err => (this.wrk = false));
                    }, 1000);
                    break;
                case "windowStart":
                    if (this.sw.ServerAdapter.subscriptionId) {
                        this.sw.ItemSubscription.AddWindow(data);
                    } else {
                        this._windows.push(data);
                    }
                    const a = document.querySelector("ms-window");
                    if (a.id == message.data.window.id) {
                        // const sf = document.getElementById(Links.mainFrame);
                        // if(message.data.window.firstChild.nodeName=='MS-WINDOW') message.data.window.firstChild.remove();
                        window.__rootWin = message.data.window;
                        window.__rootWin.borderthickness = 0;
                        window.__rootWin.setAttribute("root", "");
                        window.__rootWin.scaleRootWindow();
                        this.setGlobalEvents();
                        if (window._globalParams.OfflineMode) {
                            this.startPreview();
                        }
                    }
                    break;
                case "windowRemove":
                    this.toolTipHide();
                    this.sw.ItemSubscription.RemoveWindow(data);
                    break;
                case "logout":
                    const { username, password, callback } = message.data;

                    // Если имя не пришло, значит пароль от текущего пользователя
                    // Если пришёл пароль значит не отображаем, а отправляем на сервер как ранее
                    if (
                        window._globalParams.RequestPasswordOnLogout &&
                        !password
                    ) {
                        this.createConfirmSessionCompleteModal(
                            true,
                            username,
                            callback
                        );
                        return;
                    }

                    this.logout(
                        { sendEvent: true },
                        username,
                        password,
                        callback
                    );
                    break;
                case "switchuser":
                    if (!this.switchUserInProgress) {
                        this.switchUserInProgress = true;
                        this.switchuser(
                            message.data.username,
                            message.data.password,
                            message.data.callback
                        )
                            .then(() => {
                                this.switchUserInProgress = false;
                            })
                            .catch(() => {
                                this.switchUserInProgress = false;
                            });
                    }
                    break;
                case "serverChange":
                case "connectionLost":
                    if (!this.popup.isvisible) {
                        this.setPopupText(`${i18next.t('main_noConnectionServer')}`);
                        this.popup.isvisible = true;
                    }
                    if (this.sw.serverState.haveReserv) {
                        this.initRedirect();
                    }
                    break;
                case "sessionInvalid":
                    if (!this.loginChangeInProcess) {
                        this.loginChangeInProcess = true;
                        this.sw.Login("", "", true).then(data => {
                            if (data && data.code === 0) {
                                document.cookie = `sessionId=${data.sessionId}; expireDate=0;`;
                                this.sw.sessionId = Number(data.sessionId);
                                this.sw.ServerAdapter.constructor.restartAdapters();
                            }
                            this.loginChangeInProcess = false;
                        });
                    }
                    break;
                case "connectRestore":
                    this.popup.isvisible = false;
                    break;
                case "reconnect":
                case "projectReload":
                    // перезагрузка проекта с сервера, при изменении конфигурации проекта
                    this.reloadPage();
                    break;
                case "mplcReload":
                    this.sw.serverState.haveReserv
                        ? this.initRedirect()
                        : this.initRestartPLC();
                    break;
            }
        });
    }

    async processGetLoginData(sessionId, isRelogin) {
        await this.sw
            .GetLoginData()
            .then(data => {
                const { disableSelectUser, operators, needLogin } =
                    this.sw.serverState.LoginData;
                this.disableSelectUser =
                    (disableSelectUser || !operators.length) && needLogin;
                this.pm.hasPermissions = data.needLogin;

                if (
                    typeof sessionId !== "undefined" &&
                    data.sessionId === sessionId &&
                    data.session
                ) {
                    this.afterLogin(
                        data.session,
                        !isRelogin && this.windowId == 1
                    );
                } else if (data.code != 0x800b0000) {
                    if (
                        (!operators || operators.length == 0) &&
                        !this.disableSelectUser
                    ) {
                        this.pm.hasPermissions = false;
                        this.forcedLogin("", "");
                    } else {
                        const { currentOperator, user } =
                            this.sw.serverState.currentState;
                        if (!currentOperator || !user || !data.session) {
                            let res = null;
                            if (this.tUser) {
                                res = this.forcedLogin(
                                    this.tUser,
                                    this.tPass || "",
                                    false
                                );
                            } else if (data.defaultUser) {
                                res = this.forcedLogin(
                                    data.defaultUser,
                                    "",
                                    false
                                );
                                //delete this.tUser;
                                //delete this.tPass;
                            }
                            if (res == null || res.code != 0) {
                                this.login(false, this.disableSelectUser);
                            }
                        } else {
                            this.afterLogin(
                                data.session,
                                !isRelogin && this.windowId == 1
                            );
                        }
                    }
                }
                if (this.tryStart != null) {
                    clearInterval(this.tryStart);
                    this.tryStart = null;
                }
                if (this.tUser) {
                    window._globalParams.DefaultUser = this.tUser;
                    window._globalParams.DefaultPassword = this.tPass || "";
                } else if (data.defaultUser) {
                    window._globalParams.DefaultUser = data.defaultUser;
                    window._globalParams.DefaultPassword = "";
                }
                this.wrk = false;
            })
            .catch(error => {
                console.log("error", error);
                this.wrk = false;
            });
    }

    setPopupText(value) {
        const text = this.popup.getElementsByClassName("text")[0];
        const image = this.popup.getElementsByClassName("img")[0];
        text.innerText = value;
        image.style.visibility = "inherit";
    }

    initRedirect() {
        if (!this.serverChangeInProcess) {
            this.wrk = false;
            this.setPopupText(`${i18next.t('main_connectingBackupNode')}`);
            this.serverChangeInProcess = true;
            this.sw.Redirect().then(() => {
                this.serverChangeInProcess = false;
                this.popup.isvisible = false;
            });
        }
    }

    initRestartPLC() {
        if (!this.serverChangeInProcess) {
            this.wrk = false;
            this.setPopupText(`${i18next.t('main_reboot')}`);
            this.popup.isvisible = true;
            this.serverChangeInProcess = true;
            this.sw.RestartPLC().then(() => {
                this.serverChangeInProcess = false;
                this.popup.isvisible = false;
            });
        }
    }

    reloadPage() {
        this.sw.ItemSubscription.StopWatch();
        if (!$sw.serverState.haveReserv)
            location.reload(true);
        else
            document.location.href = location.protocol + "//" + $sw.serverState.location.hostname + ":" + window.location.port + location.pathname;;

    }

    allert(text) {
        const popup = new MSPopUpWindow();
        popup.dragable = false;
        popup.modal = true;
        popup.minimized = false;
        popup.title = "Информация";
        popup.closable = false;
        popup._popup.style.width = "auto";
        popup.innerHTML = `
        <form class="noselect Login" style="display: flex; flex-direction: column;" autocomplete="off">
            <span>${text}</span>
            <div style="text-align: center;">
                <button id="confirmOk" style="margin-top:32px;height:34px;width:100px;">${i18next.t('ok')}</button>
            </div>
        </form>
        `;
        document.body.appendChild(popup);
        popup.querySelector("#confirmOk").onclick = e => {
            e.preventDefault();
            popup.querySelector("#confirmOk").onclick = null;
            popup.isvisible = false;
            popup.remove();
        };
        popup.isvisible = true;
        popup._upWindow();
    }

    confirm(callback, ...args) {

        if (!this.confirmPopup) {
            this.confirmPopup = {};
        }
        if (args[1] && this.confirmPopup[args[1]]) {
            this.confirmPopup[args[1]].callback.push(callback);
            return;
        }

        const uid = `f${(~~(Math.random() * 1e8)).toString(16)}`;
        let title = args ? args[0] : "";
        const requirePassword = args[4]
        let confirmPopup = new MSPopUpWindow();
        confirmPopup.dragable = false;
        confirmPopup.modal = true;
        confirmPopup.minimized = false;
        confirmPopup.title = i18next.t("confirm_the_operation");
        confirmPopup.closable = false;
        confirmPopup._popup.style.width = "auto";

        const requirePasswordHTML = requirePassword ? `
            <label style="margin-top: 17px;">${i18next.t('authorization_passwordTitle')}</label>
            <input type="password" id="pass" name="pass" autocomplete="off" style="width:220px; margin-top: 5px"; />
                <label style="display: inline-flex; align-self: flex-start; align-items: center; margin-top: 10px; margin-bottom: 10px; cursor: pointer;">
                    <input type="checkbox" style="width:20px; height:auto" id="togglePassVisibility"></input>
                    Показать пароль
                </label>
            <div id="loginError" style="display: none; width: 220px; margin-bottom: 10px; color: red;">${i18next.t('authorization_wrongPassword')}</div>`
            : "";
        confirmPopup.innerHTML = `
             <form class="noselect Login" style="display: flex; flex-direction: column;" autocomplete="off">
                 <span>${title}</span>
                 ${requirePasswordHTML}
                 <div>
                     <button ok data-uid="${uid}" style="margin-top:32px;height:34px;width:100px;margin-right:16px;">${i18next.t('ok')}</button>
                     <button cancel data-uid="${uid}" style="margin-top:32px;height:34px;width:100px;">${i18next.t('cancel')}</button>
                 </div>
            </form>`

        const passInput = confirmPopup.querySelector("#pass");
        if (requirePassword) {
            confirmPopup.querySelector("#togglePassVisibility").onclick = e => {
                pass.type = pass.type === "password" ? "text" : "password";
            }
        }

        document.body.appendChild(confirmPopup);
        confirmPopup.uid = uid;

        confirmPopup.querySelector("[ok]").onclick = async e => {
            if (e) {
                e.preventDefault();
                e.stopPropagation();
            }

            if (passInput) {
                const login = this.sw.serverState.UserData.user;
                const isValidPassword = await this.validatePassword(login, passInput.value);
                if (!isValidPassword) {
                    const errorElem = confirmPopup.querySelector("#loginError");
                    errorElem.style.display = "block";
                    return;
                }
            }

            const { beforeCallbackFn, afterCallbackFn } = args[3] || {};
            const popup = this.confirmPopup[confirmPopup.uid].popup;
            const callbackLocal = this.confirmPopup[confirmPopup.uid].callback;
            popup.isvisible = false;
            beforeCallbackFn && beforeCallbackFn();
            callbackLocal.forEach(element => {
                element();
            });
            afterCallbackFn && afterCallbackFn();
            delete this.confirmPopup[confirmPopup.uid];
            confirmPopup.querySelector("[ok]").onclick = null;
            confirmPopup.remove();
            confirmPopup = null;
        };

        confirmPopup.querySelector("[cancel]").onclick = e => {
            e.preventDefault();
            e.stopPropagation();
            if (args[2]) args[2]();
            const popup = this.confirmPopup[confirmPopup.uid].popup;
            popup.isvisible = false;
            delete this.confirmPopup[confirmPopup.uid];
            confirmPopup.querySelector("[cancel]").onclick = null;
            confirmPopup.remove();
            confirmPopup = null;
        };
        confirmPopup.default = confirmPopup.querySelector("[ok]").onclick;
        this.confirmPopup[uid] = { popup: confirmPopup, callback: [callback] };
        confirmPopup.isvisible = true;
        confirmPopup._upWindow();
        return uid;
    }

    async validatePassword(login, password) {
        const loginTestData = await this.sw.LoginTest(login, password);
        const { code } = loginTestData;

        return code === 0;
    }

    async login(relogin, disableSelectUser, skipGetLoginData) {
        if (relogin && !skipGetLoginData) {
            await this.sw.GetLoginData().then(data => {
                setTimeout(() =>
                    this.login(true, this.disableSelectUser, true)
                );
            });
            return;
        }

        if (typeof disableSelectUser === "undefined") {
            return;
        }

        this.popup.isvisible = false;

        if (!this.docLoginForm) {
            const uri = new URLSearchParams(document.location.search);

            const loginForm = this.createLoginForm(
                uri,
                disableSelectUser,
                relogin
            );

            this.docLoginForm = document.body.appendChild(loginForm);
            this.LoginFormChangePassword =
                this.docLoginForm.querySelector("div#chPass");
            this.LoginFormWarning =
                this.docLoginForm.querySelector("#loginError");
            this.docLoginForm._upWindow();

            const usr = uri.get("user") || "";
            if (!this.endTryLoginUri && typeof usr === "string" && usr) {
                this.endTryLoginUri = true;
                loginForm.onsubmit();
            }
        }
    }

    createLoginForm(uri, disableSelectUser, relogin) {
        const loginForm = new MSPopUpWindow();
        loginForm.dragable = false;
        loginForm.modal = true;
        loginForm.minimized = false;
        loginForm.title = `${i18next.t('authorization_loginFormTitle')}`;
        loginForm.closable = relogin;
        loginForm._popup.style.width = "auto";

        loginForm.innerHTML = `
            <div style="display:flex; flex-direction: row;">
                <form class="noselect Login" style="display: flex; flex-direction: column;margin: 20px;" autocomplete="off">
                    <label>${i18next.t('authorization_loginTitle')}</label>
                    ${this.createLoginFormOptions(
            disableSelectUser,
            uri.get("user") || ""
        )}
                    <label style="margin-top: 17px;">${i18next.t('authorization_passwordTitle')}</label>
                    <input type="password" id="pass" name="pass" value="${uri.get("password") || ""
            }">
                    <label style="margin-top: 17px;">
                        ${i18next.t('authorization_showPasswordTitle')}
                        <input type="checkbox" style="width:20px; height:auto" id="togglePassVisibility"></input>
                    </label>
                    <div id="loginError" style="display: none;width: 300px;margin-top: 10px;color: red;">${i18next.t('authorization_loginError')}</div>
                    <div id="chPass" style="display: none; flex-direction: column;">
                        <div style="width: 300px;margin-top: 10px;color: red;">${i18next.t('authorization_needChangePassword')}</div>
                        <label style="margin-top: 17px;">${i18next.t('authorization_newPassword')}</label>
                        <input type="password" id="newPass" name="newPass" value="">
                        <label style="margin-top: 17px;">${i18next.t('authorization_repeatPassword')}</label>
                        <input type="password" id="reNewPass" name="reNewPass" value="">
                        <div id="newPassError" style="display:none;width:300px;margin-top:10px;color:red;"></div>
                    </div>
                    <button style="margin-top: 32px; height: 34px;">${i18next.t('authorization_loginBtn')}</button>
                </form>
                <div id="passInfo" style="display:none;flex-direction: column;border-left: 1px solid gray;padding: 20px;">
                    <span>${i18next.t('authorization_information')}</span>
                    <pre style="background-color:lightgray;padding:10px;border: 1px solid;height:100%;margin-bottom:0;"></pre>
                    <button id="passCancel" class="btnInfo" style="margin-top: 32px; min-height: 34px;">${i18next.t('cancel')}</button>
                <div>
            </div>
        `;

        loginForm.querySelector("#togglePassVisibility").onclick = e => {
            const pass = loginForm.querySelector("#pass");
            pass.type = pass.type === "password" ? "text" : "password";

            const newPass = loginForm.querySelector("#newPass");
            newPass.type = newPass.type === "password" ? "text" : "password";

            const reNewPass = loginForm.querySelector("#reNewPass");
            reNewPass.type =
                reNewPass.type === "password" ? "text" : "password";
        };

        loginForm.querySelector("#passCancel").onclick = e => {
            e.preventDefault();
            this.LoginFormChangePassword.querySelector("#newPassError").innerText = '';
            this.LoginFormChangePassword.querySelector("#newPass").value = "";
            this.LoginFormChangePassword.querySelector("#reNewPass").value = "";

            this.LoginFormChangePassword.style.display = "none";
            this.docLoginForm.querySelector("#passInfo").style.display = "none";
            const form = this.docLoginForm.querySelector("form");
            form.elements.operator.disabled = false;
            form.elements.pass.disabled = false;
            this._chSendPass = false;
            if (this._passInfo) {
                delete this._passInfo;
            }
        };

        const dropdownItems = Array.from(loginForm.querySelectorAll(".dropdown-item"));
        const operatorInput = loginForm.querySelector("#operator-input");
        if (operatorInput) {
            operatorInput.oninput = e => {
                const filter = e.target.value.toLowerCase();
                dropdownItems.forEach(item => {
                    item.style.display = item.textContent.toLowerCase().includes(filter) ? "" : "none";
                });
            }
        }

        loginForm.onsubmit = e => {
            e.preventDefault();
            const form = loginForm.querySelector("form");
            const login = form.elements.operator.value;
            const passValue = form.elements.pass.value;

            if (this._chSendPass) {
                const newPass = form.elements.newPass.value;
                const reNewPass = form.elements.reNewPass.value;
                if (
                    this._passInfo &&
                    this._passInfo.passwordMinSize > 0 &&
                    !newPass
                ) {
                    this.showPassErr(
                        loginForm.querySelector("#newPassError"),
                        i18next.t("authorization_error_newPasswordNoSpecified")
                    );
                    return false;
                } else if (newPass !== reNewPass) {
                    this.showPassErr(
                        loginForm.querySelector("#newPassError"),
                        i18next.t("authorization_error_PasswordsNomatch")
                    );
                    return false;
                }
                this.forcedLogin(login, passValue, relogin, newPass);
            } else {
                this.forcedLogin(login, passValue, relogin);
            }


            if (this._passInfo) {
                delete this._passInfo;
            }
            return false;
        };

        loginForm._close.onclick = () => {
            this.closeForm()
        };

        this.clickHandler = this.handleClick.bind(this);
        document.addEventListener('click', this.clickHandler);

        return loginForm;
    }

    createLoginFormOptions(disableSelectUser, usr) {
        const inputField = `<input list="operators" name="operator" value="${usr}" style="padding: 2px">`;
        if (usr || window._globalParams.ManuallyEnteringLogin || disableSelectUser) {
            return inputField;
        }

        const operators = this.sw.serverState.LoginData.operators;
        const options = operators.map(element => `<li class="dropdown-item">${element.login}</li>`).join('');

        return `
            <div class="dropdown-container" id="container">
                <input type="text" id="operator-input" value="${usr || operators[0].login}" name="operator">
                <span class="arrow">&#9660;</span>
                <div class="dropdown-list" id="dropdown-list" style="display: none;">
                    <ul>${options}</ul>
                </div>
            </div>
            <style>
                .arrow {
                    position:absolute;
                    right: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    pointer-events: none;
                }
                .dropdown-container {
                    position: relative;
                    display: inline-block;
                }
                .dropdown-list {
                    position: absolute;
                    background-color: #f9f9f9;
                    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
                    z-index: 100000000;
                }
                .dropdown-list ul {
                    list-style-type: none;
                    padding: 0;
                    margin: 0;
                }
                .dropdown-item {
                    padding: 6px 10px;
                    cursor: pointer;
                
                }
                .dropdown-item:hover {
                    background-color: #2C6FD7;
                    color: white;
                }
            </style>`;
    }

    handleClick(event) {
        const input = this.docLoginForm.querySelector('input#operator-input');
        const dropdown = document.getElementById('dropdown-list');

        if (input && dropdown) {
            const target = event.target;
            const isInputClick = input.contains(target);
            const isDropdownClick = dropdown.contains(target);

            if (!isInputClick && !isDropdownClick) {
                dropdown.style.display = 'none';
            }

            if (isInputClick) {
                const isDropdownVisible = dropdown.style.display === 'block';
                dropdown.style.display = isDropdownVisible ? 'none' : 'block';

                if (!isDropdownVisible) {
                    const { left, top, height, width, bottom } = input.getBoundingClientRect();
                    const windowHeight = window.innerHeight;
                    const spaceBelow = windowHeight - bottom;
                    const itemHeight = dropdown.querySelector('li').offsetHeight;
                    const maxVisibleItems = 20;
                    const maxHeight = itemHeight * maxVisibleItems;

                    dropdown.style.left = `${left}px`;
                    dropdown.style.top = `${top + height}px`;
                    dropdown.style.width = `${width}px`;
                    dropdown.style.maxHeight = `${Math.min(spaceBelow, maxHeight)}px`;
                    dropdown.style.overflowY = 'auto';

                    document.body.appendChild(dropdown);
                }
            }

            if (target.classList.contains('dropdown-item')) {
                input.value = target.textContent;
                dropdown.style.display = 'none';
            }
        }
    }

    showPassErr(err, innerText) {
        err.innerText = innerText;
        err.style.display = "";
    }

    async forcedLogin(login, pass, relogin, newPass) {
        // при смене пароля не надо вызывать LoginTest
        // также, проверку нужно вызывать, только если есть пользователи
        const userRoles = this.getUserRoles(login);
        const { operators, roles } = this.sw.serverState.LoginData;
        if (!newPass && operators.length) {
            const validationData = this.getDataForRoleValidation(userRoles);
            if (validationData.length) {
                const loginTestData = await this.sw.LoginTest(login, pass);
                const { code } = loginTestData;

                if (code === 2149515265 || code === 2149515269) {
                    this.showChangePasswordForm(login);
                    return;
                }

                if (code === 0) {
                    if (!this.isPasswordValid(validationData)) {
                        this.showChangePasswordForm(login);
                        return;
                    }
                } else {
                    const checkedData = this.checkLoginDataCode(
                        loginTestData,
                        login
                    );
                    if (checkedData) {
                        return checkedData;
                    }
                }
            }
        }

        return await this.sw
            .Login(login, pass, relogin, newPass)
            .then(data => {
                const checkedData = this.checkLoginDataCode(data, login);
                if (checkedData) {
                    return checkedData;
                }

                if (window.ipc) {
                    const disableOSAccess = roles.some(
                        ({
                            name, // Название роли
                            disableOSAccess, // отключить доступ до операционной системы
                        }) => {
                            const userHasRole = userRoles.indexOf(name) !== -1;
                            return userHasRole && disableOSAccess;
                        }
                    );

                    const error = this.ipc.sendSync(
                        "server",
                        disableOSAccess ? "WinBlock.CADon" : "WinBlock.CADoff"
                    );
                    if (error) {
                        $ns.add({
                            type: "error",
                            time: new Date().toLocaleString(),
                            title: `${i18next.t('authorization_blockingAccessSystem')}`,
                            text: error,
                        });
                    }
                }
                document.cookie = `sessionId=${data.sessionId}; expireDate=0;`;
                this.sw.serverState.UserData.user = login;
                this.sw.serverState.currentState = data;
                this.sw.sessionId = Number(data.sessionId);

                if (this.docLoginForm) {
                    this.closeForm();
                    this._chSendPass = false;
                }
                this.pm.setRtRights(data);
                this.afterLogin(data, true);
            })
            .catch(error => {
                console.log("error", error);
            });
    }

    closeForm() {
        document.getElementById('dropdown-list')?.remove();
        this.docLoginForm.close();
        this.docLoginForm.remove();
        this.docLoginForm = undefined;
        document.removeEventListener('click', this.clickHandler);
    }

    isPasswordValid(validationData) {
        const passwordData = validationData.map(
            ({ passwordMinSize, passwordIsComplex, passwordRequiresSpecChars }) => ({
                // На стороне клиента нужно валидировать только 3 параметра:
                passwordMinSize, // Минимальная длина пароля
                passwordIsComplex, // Использовать сложный пароль
                passwordRequiresSpecChars, // Пароль должен содержать спецсимвол
            })
        );
        const mustBeComplex = passwordData.some(({ passwordIsComplex }) => passwordIsComplex);
        const requiresSpecChars = passwordData.some(({ passwordRequiresSpecChars }) => passwordRequiresSpecChars);
        const password = this.docLoginForm.querySelector("form").elements.pass.value;
        const isComplexValid = mustBeComplex ? this.isPasswordComplex(password) : true;
        const hasSpecCharsValid = requiresSpecChars ? this.hasSpecChars(password) : true;
        const isMinSizeValid = passwordData.every(({ passwordMinSize }) => password.length >= passwordMinSize);
        return isComplexValid && isMinSizeValid && hasSpecCharsValid;
    }

    getDataForRoleValidation(userRoles) {
        return this.sw.serverState.LoginData.roles.filter(
            ({
                name, // Название роли
                passwordMinSize, // Минимальная длина пароля
                passwordNonRepeatingCount, // Количество не повторяемых паролей
                passwordIsComplex, // Использовать сложный пароль
                passwordRequiresSpecChars, // Пароль должен содержать спецсимвол
            }) => {
                const userHasRole = userRoles.indexOf(name) !== -1;

                // Пользователь может содержать роль, но если у этой роли нету никаких параметров для валидации, например,
                // минимальная длина пароля: 0, то и валидировать по этим параметрам нету смысла.
                // Причём может возникнуть такая ситуация, что "Минимальная длина пароля: 0", "Использовать сложный пароль: false",
                // но при этом всё равно нужно делать запрос на сервер "TestLogin",
                // потому что "Количество не повторяемых паролей: 5", а этот параметр будет уже проверяться на сервере.
                const hasData =
                    passwordMinSize ||
                    passwordNonRepeatingCount ||
                    passwordIsComplex ||
                    passwordRequiresSpecChars;

                return userHasRole && hasData;
            }
        );
    }

    isPasswordComplex(password) {
        let hasLowerCase = false;
        let hasUpperCase = false;
        let hasNumber = false;
        for (let sign of password) {
            if (/\d+/.test(sign)) {
                hasNumber = true;
                continue;
            }

            if (sign === sign.toLowerCase() && sign !== sign.toUpperCase()) {
                // проверка на upperCase нужна, поскольку есть символы, совпадающие в верхнем и нижнем регистре
                hasLowerCase = true;
                continue;
            }

            if (sign === sign.toUpperCase() && sign !== sign.toLowerCase()) {
                hasUpperCase = true;
                continue;
            }
        }

        return hasLowerCase && hasUpperCase && hasNumber;
    }

    hasSpecChars(password) {
        const specChars = /[`~!@#$%^&*()\-—_+={}[\]\/\\|:;'"<>,.?]/;
        return specChars.test(password);
    }

    showChangePasswordForm(login) {
        // окно смены пароля
        // OpcUa_BadUserAccessDenied_PasswordExpired, OpcUa_BadUserAccessDenied_NeedChangePassword
        this.LoginFormWarning.style.display = "none";
        this.LoginFormChangePassword.style.display = "flex";
        this.docLoginForm.querySelector("#passInfo").style.display = "flex";
        this._passInfo = this.generateInfoPassword(login);
        this.docLoginForm.querySelector("pre").innerHTML = this._passInfo.text;
        const form = this.docLoginForm.querySelector("form");
        form.elements.operator.disabled = true;
        form.elements.pass.disabled = true;
        form.elements.newPass.focus();
        this._chSendPass = true;
    }

    generateInfoPassword(login) {
        let passwordMinSize = 0;
        let passwordNonRepeatingCount = 0;
        let passwordIsComplex = false;
        let passwordRequiresSpecChars = false;
        let passwordExpirationTime = 0;
        let sessionDuration = 0;

        const index = this.sw.serverState.LoginData.operators.findIndex(
            el => el.login === login
        );
        const operatorGroup = this.sw.serverState.LoginData.operators[
            index
        ].groups.concat(this.pm.allRoleConst);
        const groups = this.sw.serverState.LoginData.roles;

        for (const iterator of groups) {
            const i = operatorGroup.indexOf(iterator.name);
            if (i > -1) {
                passwordMinSize = iterator.passwordMinSize > passwordMinSize ? iterator.passwordMinSize : passwordMinSize;
                passwordNonRepeatingCount = iterator.passwordNonRepeatingCount > passwordNonRepeatingCount
                    ? iterator.passwordNonRepeatingCount
                    : passwordNonRepeatingCount;
                passwordIsComplex = iterator.passwordIsComplex || passwordIsComplex;
                passwordRequiresSpecChars = iterator.passwordRequiresSpecChars || passwordRequiresSpecChars;
                passwordExpirationTime = (iterator.passwordExpirationTime <= passwordExpirationTime || passwordExpirationTime === 0)
                    && iterator.passwordExpirationTime > 0
                    ? iterator.passwordExpirationTime
                    : passwordExpirationTime;
                sessionDuration = (iterator.sessionDuration <= sessionDuration || sessionDuration === 0)
                    && iterator.sessionDuration > 0
                    ? iterator.sessionDuration
                    : sessionDuration;
            }
        }

        let text = `${i18next.t("authorization_sessionDuration")}: ${window._df.dateFormatTimeSpan(sessionDuration / 10000)}<br>`;
        text += `${i18next.t("authorization_passwordMinSize")}: ${passwordMinSize}<br>`;
        text += `${i18next.t("authorization_passwordNonRepeatingCount")}: ${passwordNonRepeatingCount}<br>`;
        text += `${i18next.t("authorization_passwordExpirationTime")}: ${window._df.dateFormatTimeSpan(passwordExpirationTime / 10000)}<br>`;
        text += `${i18next.t("authorization_passwordIsComplex")}: ${passwordIsComplex ? "Да" : "Нет"}<br>`;
        text += `${i18next.t("authorization_passwordContainSpec")}: ${passwordRequiresSpecChars ? "Да" : "Нет"}`;
        return {
            text,
            passwordMinSize,
            passwordNonRepeatingCount,
            passwordIsComplex,
            passwordExpirationTime,
            sessionDuration,
            passwordRequiresSpecChars
        };
    }

    checkLoginDataCode(data, login) {
        let { code, errorText, codeDescription } = data;
        if (code === 2149580800) {
            // mplc пока не локализован
            codeDescription = i18next.t("authorization_log_pass_error");
        }
        // если data не вернулась то показать сообщение об ошибке логина
        if (typeof data === "undefined" || code === 2153119744) {
            return data;
        } else if (code === 2149515265 || code === 2149515269) {
            this.showChangePasswordForm(login);
            return data;
        } else if (code != 0) {
            if (this._chSendPass) {
                const err = this.docLoginForm.querySelector("#newPassError");
                err.innerText = errorText || codeDescription;
                err.style.display = "";
            } else if (this.docLoginForm) {
                this.LoginFormWarning.style.display = "block";
                this.LoginFormWarning.innerHTML = errorText || codeDescription;
            } else if (code != 2148270080) {
                // restart
                $ns.add({
                    type: "warning",
                    time: new Date().toLocaleString(),
                    title: i18next.t("authorization_changingUser"),
                    text: String.format(i18next.t("authorization_error_login"), login, errorText, codeDescription),
                });
            }
            console.log(code.toString(16));
            return data;
        }
    }

    getUserRoles(login) {
        // Роль "_All" по умолчанию есть у всех пользователей хоть и не указана в operatorsRoles,
        // поэтому её тоже нужно учитывать
        return (
            this.sw.serverState.LoginData.operators.find(x => x.login === login)
                ?.groups || []
        ).concat(this.pm.allRoleConst);
    }

    getActiveMonitorTemplate() {
        const monitors = this.getMonitors();
        const availableTemplates = this.getAvailableTemplates();
        const monitorsTemplates = this.assignTemplatesToMonitors(monitors, availableTemplates);
        return this.getActiveMonitorElement(monitorsTemplates);
    }
    
    getMonitors() {
        const monitors = this.ipc 
            ? this.ipc.sendSync("server", "getMonitors")
            : null;
    
        return monitors ?? [{ width: window.screen.availWidth, height: window.screen.availHeight, isActive: true }];
    }
    
    getAvailableTemplates() { 
        return Object.entries(JSON.parse(window._globalParams.ScreensOptions))
            .map(([id, data]) => ({ 
                id, 
                data 
            }))
            .sort((a, b) => a.data.Index - b.data.Index);
    }
    
    assignTemplatesToMonitors(monitors, availableTemplates) {
        const templatesWithCriteria = availableTemplates.some(template => {
            const options = template.data.ScreenCheckingOptions || {};
            return options.ScreenChecking || options.CheckScreenOrientation || options.CheckTouchScreen;
        });
    
        return templatesWithCriteria
        ?   this.assignByScore(monitors, availableTemplates)
        :   this.assignCyclically(monitors, availableTemplates);
    }

    assignByScore(monitors, availableTemplates) {
        return monitors.map(monitor => {
            const bestTemplate = this.getBestTemplateId(monitor, availableTemplates);
            return { monitor, bestTemplate };
        });
    }

    assignCyclically(monitors, availableTemplates) {
        let templateIndex = 0;
        let assignedTemplates = [];
    
        return monitors.map(monitor => {
            if (assignedTemplates.length === availableTemplates.length) {
                assignedTemplates = [];
            }

            while (assignedTemplates.includes(availableTemplates[templateIndex].id)) {
                templateIndex = (templateIndex + 1) % availableTemplates.length;
            }
    
            const selectedTemplate = availableTemplates[templateIndex].id;
            assignedTemplates.push(selectedTemplate);
            templateIndex = (templateIndex + 1) % availableTemplates.length;
    
            return { monitor, bestTemplate: selectedTemplate };
        });
    }
    
    getActiveMonitorElement(monitorsTemplates) {
        const activeTemplate = monitorsTemplates.find(item => item.monitor.isActive).bestTemplate;
        return document.getElementById(activeTemplate);
    }

    getBestTemplateId(monitor, availableTemplates) { 
        const { deviations, aspectRatioDeviations } = this.calculateDeviations(availableTemplates, monitor.width, monitor.height);
        
        const minDeviationTemplate = deviations.reduce((minTemplate, currentTemplate) => {
            return currentTemplate.deviation < minTemplate.deviation ? currentTemplate : minTemplate;
        });
        const minAspectRatioTemplate = aspectRatioDeviations.reduce((minTemplate, currentTemplate) => {
            return currentTemplate.aspectRatioDeviation < minTemplate.aspectRatioDeviation ? currentTemplate : minTemplate;
        });
    
        return availableTemplates.reduce((bestTemplate, template) => {
            const score = this.calculateTemplateScore(template, minDeviationTemplate.deviation, minAspectRatioTemplate.aspectRatioDeviation, monitor, deviations, aspectRatioDeviations);
    
            // Если баллы одинаковые, возвращаем текущий шаблон по порядку
            const isBetterTemplate = score > bestTemplate.maxScore;
    
            return isBetterTemplate ? { template, maxScore: score } : bestTemplate;
            
        }, { template: availableTemplates[0], maxScore: -1 }).template.id;
    }
    
    calculateTemplateScore(template, minDeviation, minAspectRatio, monitor, deviations, aspectRatioDeviations ) {
        const { ScreenCheckingOptions } = template.data;
        const { ScreenOrientation, CheckTouchScreen, ScreenChecking, CheckScreenOrientation } = ScreenCheckingOptions; 
        const isTemplatePortrait = ScreenOrientation === 1;
        let score = 0;
    
        if (ScreenChecking === 1 && (deviations.find(dev => dev.key === template.id)).deviation === minDeviation) score++;
        if (ScreenChecking === 2 && (aspectRatioDeviations.find(elem => elem.key === template.id)).aspectRatioDeviation === minAspectRatio) score++;
        if (CheckScreenOrientation && ((monitor.height > monitor.width && isTemplatePortrait) || (monitor.height < monitor.width && !isTemplatePortrait))) score++;
        if (CheckTouchScreen && ('ontouchstart' in window || navigator.maxTouchPoints > 0)) score++;
    
        return score;
    }
    
    calculateDeviations(availableTemplates, width, height) {
        return availableTemplates.reduce((acc, template) => {
            const { ScreenCheckingOptions } = template.data;
            const { ScreenWidth, ScreenHeight } = ScreenCheckingOptions;
    
            const deviation = Math.sqrt(
                Math.pow(ScreenWidth - width, 2) + Math.pow(ScreenHeight - height, 2)
            );
            const aspectRatioDeviation = Math.abs(
                (width / height) - (ScreenWidth / ScreenHeight)
            );
            acc.deviations.push({ key: template.id, deviation });
            acc.aspectRatioDeviations.push({ key: template.id, aspectRatioDeviation });
    
            return acc;
        }, { deviations: [], aspectRatioDeviations: [] });
    }

    updateMainTemplate(activeMonitorTemplate) {
        document.querySelectorAll("ms-window").forEach(template => {
            if (template !== activeMonitorTemplate) template.remove()
        })
        activeMonitorTemplate.renderMainWindow();
    }
    
    afterLogin(data, sendSession) {
        if (this.ipc && sendSession) {
            this.ipc.send("server", "session", {
                data: data,
                login: this.sw.serverState.UserData.user,
                userData: this.sw.serverState.UserData,
            });
        }
        let user = data.user;
        let roles = data.groups;

        this.sw.sessionId = Number(data.sessionId);
        this.sw.serverState.LoginTime = data.serverTime;
        this.pm.setOperatorRoles(user, roles);

        if (this._stateCreated) {
            //если окно дозволено, то выставляем активность
            //если запрещено, то нужно открыть стартовое окно пользователя
            if (this.pm.checkCurrentWindow()) {
                const event = new CustomEvent("ms_message");
                event.data = { event: "afterswitch" };
                window.dispatchEvent(event);
            } else {
                let pmStart =
                    this.pm.getStartWindow() ||
                    data.startMnemoscheme ||
                    WinDefs.startWindow[window.activeMonitorTemplateId];
                    this.pm.openUserWindow(pmStart);
            }
        } else {
            const activeTemplate = this.getActiveMonitorTemplate()
            this.updateMainTemplate(activeTemplate)
            let storedWindowId;
            window.activeMonitorTemplateId = activeTemplate.id;
            const frame = document.getElementById(
                $WinDefs.constructor.mainFrame[window.activeMonitorTemplateId]
            );
            
            if (toBool(frame.getAttribute("saveWindowState"))) {
                storedWindowId = $ss.getItemState(frame.getOriginPath())
                    ?.windowState.windowId;
            }
            const pmStart = this.pm.getStartWindow() || data.startMnemoscheme;
            const startMnemoStr =
                this.customStatWin ||
                pmStart ||
                storedWindowId;
            let startMnemo = null;
            if (startMnemoStr) {
                const startMnemoString = typeof startMnemoStr === 'string' ? startMnemoStr : String(startMnemoStr)
                const list = startMnemoString.includes(",") ? startMnemoString.split(",") : [startMnemoString]
                if (this.windowId <= list.length)
                    startMnemo = list[this.windowId - 1];
            }
            if (!startMnemo)
                startMnemo = $WinDefs.constructor.startWindow[window.activeMonitorTemplateId];
            this.customStatWin = null;

            if (startMnemo && !this.pm.openUserWindow(startMnemo)) {
                this.login(false, this.disableSelectUser);
                return;
            }
        }

        if (!this._stateCreated) {
            this.SetState();
            this.zoom();
        } else this.sw.ServerAdapter.constructor.restartAdapters();

        if (this.docLoginForm) {
            this.closeForm()
        }

        if (data.sessionIdleTime) {
            this.pm.startWatchUserActivity(data.sessionIdleTime, () => {
                this.logout({ sendEvent: true });
            });
        } else {
            // очищаем таймер, который мог быть у предыдущего пользователя, если была смена пользователя
            this.pm.stopWatchUserActivity();
        }
    }

    logout(option, username, password, callback) {
        this.pm.stopWatchUserActivity();
        this.sw.ItemSubscription.StopWatch();
        this.sw
            .Logout(username, password)
            .then(data => {
                if (callback) callback(data);
                if (typeof data === "undefined" || data.code !== 0) {
                    if (!callback)
                        $ns.add({
                            type: "warning",
                            time: new Date().toLocaleString(),
                            title: i18next.t("authorization_logout"),
                            text: data.errorText
                                ? data.errorText
                                : data.codeDescription,
                        });
                } else {
                    const hostname = $sw.serverState.haveReserv ? $sw.serverState.location.hostname : location.hostname;
                    const clean_uri = location.protocol + "//" + hostname + ":" + window.location.port + location.pathname;
                    if (!$sw.serverState.haveReserv)
                        window.history.replaceState({}, document.title, clean_uri);
                    if (this.ipc && (!option || option.sendEvent))
                        this.ipc.send("server", "logout");
                    document.location.href = clean_uri;
                }
            })
            .catch(error => {
                console.log("error", error);
                this.reloadPage();
            });
    }

    createConfirmSessionCompleteModal(sendEvent, username, callback) {
        const window = new MSPopUpWindow();
        window.dragable = false;
        window.modal = true;
        window.minimized = false;
        window.title = i18next.t("session_endSession");
        window.closable = false;
        window.innerHTML = `
            <form class="noselect Login" style="display: flex; flex-direction: column;margin: 20px;" autocomplete="off">
                <label>${i18next.t('authorization_loginTitle')}</label>
                <input type="text" name="operator" value="${username || this.pm.currentOp
            }" />
                <label style="margin-top: 17px;">${i18next.t('authorization_passwordTitle')}</label>
                <input type="password" id="pass" name="pass" autocomplete="off" />
                <label style="display: inline-flex; align-self: flex-start; align-items: center; margin-top: 17px; margin-bottom: 10px; cursor: pointer;">
                    <input type="checkbox" style="width:20px; height:auto" id="togglePassVisibility"></input>
                    ${i18next.t("main_show_password")}
                </label>
                <div id="loginError" style="display: none; width: 300px; margin-bottom: 10px; color: red;"></div>
                <div style="display: flex; justify-content: space-between; gap: 25px;">
                    <button type="submit" style="height: 34px; flex: 1; border-radius: 7px; cursor: pointer;">${i18next.t('session_complete')}</button>
                    <button type="button" style="height: 34px; flex: 1; border-radius: 7px; cursor: pointer;" id="passCancel" class="btnInfo">${i18next.t('cancel')}</button>
                </div>
            </form>
        `;

        document.body.appendChild(window)._upWindow();

        window.querySelector("#togglePassVisibility").onclick = e => {
            const x = window.querySelector("#pass");
            x.type = x.type === "password" ? "text" : "password";
        };

        window.querySelector("#passCancel").onclick = e => {
            window.close();
        };

        window.onsubmit = e => {
            e.preventDefault();

            const { operator, pass } = window.querySelector("form");

            this.logout({ sendEvent }, operator.value, pass.value, data => {
                callback?.();

                if (data.errorText) {
                    const error = window.querySelector("#loginError");
                    error.innerHTML = data.errorText;
                    error.style.display = "block";
                }
            });
        };
    }

    async switchuser(login, pass, callback) {
        if (login) {
            const data = await this.forcedLogin(login, pass, true);
            if (callback) callback(data);
        } else {
            await this.login(true, this.disableSelectUser);
        }
    }

    setGlobalEvents() {
        const node = window.__rootWin;
        if (typeof node.actionlist === "object") {
            node.removeListeners();
            let actionList = node._actionslist;
            for (const key in actionList) {
                if (actionList.hasOwnProperty(key)) {
                    document.addEventListener(
                        key,
                        node.CallActionManager.bind(node, actionList[key]),
                        false
                    );
                }
            }
        }
    }

    SetState() {
        this._stateCreated = true;
        this.sw.ItemSubscription.CreateDataSubscription().then(data =>
            this.onConnect(data)
        );
    }

    onConnect(Obj) {
        if (Obj.subscriptionId) {
            this.sw.ItemSubscription.RunScreenTask();
            this.sw.ItemSubscription.AddWindows(this._windows);
            this._windows = [];
            this.sw.StartWatchState();
            this.sendDataToFb();
            this.popup.isvisible = false;
        } else {
            console.log(Obj);
        }
    }

    sendDataToFb() {
        if (!this.sw.ItemSubscription.TaskManager?.hasTasks) {
            return;
        }
        const data = localStorage.getItem(`retain_${this.pm.currentOp}`);
        if (data) {
            const { worker } = this.sw.ItemSubscription.TaskManager.getTask();
            worker.postMessage({
                isLoadRetain: true,
                input: JSON.parse(data)
            });
        }
    }

    tooltipPosition(target, tooltipElem) {
        const { top, left, bottom, width } = target.getBoundingClientRect();
        const windowWidth = window.innerWidth;
        const tooltipWidth = tooltipElem.offsetWidth;
        let leftPos = left + (width - tooltipWidth) / 2;
        let rightPos = "auto";
    
        if (leftPos < 0) {
            leftPos = 0;
        }
        const maxLeftPos = windowWidth - tooltipWidth;
        if (leftPos > maxLeftPos) {
            rightPos = 0;
        }

        let topPos = top - tooltipElem.offsetHeight - 5;
        if (topPos < 0) {
            topPos = bottom + 5;
        }
    
        return { left: leftPos, right: rightPos, top: topPos };
    }

    setTooltipStyles(tooltipElem, screenOptions) {
        tooltipElem.style.fontStyle = toBool(screenOptions.Italic) ? "Italic" : "normal";
        tooltipElem.style.fontWeight = toBool(screenOptions.Bold) ? "bold" : "normal";
        tooltipElem.style.textDecoration = toBool(screenOptions.Underline) ? "underline" : '';
        tooltipElem.style.color = screenOptions.TextColor;
        tooltipElem.style.fontFamily = screenOptions.FontName;
        tooltipElem.style.fontSize = `${screenOptions.FontSize}px`;
        tooltipElem.style.borderRadius = `${screenOptions.CornerRadius}px`;
        tooltipElem.style.border = `${screenOptions.BorderThickness}px solid ${screenOptions.BorderColor}`
        // Прозрачность и цвет фона подсказки 
        const currentColor = getConvertedValue(screenOptions.BackgroundFill);
        const colorObj = ARGBtoObj(currentColor);
        const opacity = screenOptions.Transparency * 0.01;
        colorObj.a = Math.round(opacity * 255)
        const colorOpacity = objToCSS(colorObj);
        tooltipElem.style.backgroundColor = colorOpacity;
    }
    
    toolTipShow(event) {
        const target = event.target;
        let tooltipHtml = target.dataset.tooltip;
        let node = event.target.parentNode;
        while (!tooltipHtml && node && node.tagName !== "BODY") {
            tooltipHtml = node.dataset ? node.dataset.tooltip : null;
            if (node.nodeName === "MS-POPUP") {
                node = window.__rootWin;
            } else {
                node = node.parentNode;
            }
        }

        if (!tooltipHtml) {
            return;
        }

        let tmp = tooltipHtml.split("\n").join("</br>");

        this.toolTipHide();
        tooltipHtml = tmp;
        this.tooltipElem = document.createElement("div");
        this.tooltipElem.className = "tooltip";
        this.tooltipElem.innerHTML = tooltipHtml;
        this.screenOptions = JSON.parse(window._globalParams.ScreensOptions)[window.activeMonitorTemplateId].ToolTipSettings;

        document.body.append(this.tooltipElem);
        const { left, right, top } = this.tooltipPosition(target, this.tooltipElem);

        if (right === 0) {
            this.tooltipElem.style.right = "0px";
        } else {
            this.tooltipElem.style.left = `${left}px`;
        }
        this.tooltipElem.style.top = `${top}px`;

        this.setTooltipStyles(this.tooltipElem, this.screenOptions)
    }
    
    toolTipHide() {
        if (this.tooltipElem) {
            this.tooltipElem.remove();
            this.tooltipElem = null;
        }
    }

    async startPreview() {
        // в режиме предпросмотра метод afterLogin вызван не будет,
        // в связи с чем и не будет вызван метод `renderMainWindow`,
        // поэтому вызываем его здесь:
        document.querySelector("ms-window").renderMainWindow();
        this.popup.isvisible = false;
        this.pm.hasPermissions = false;
        const frame = document.getElementById(Object.values($WinDefs.constructor.mainFrame)[0]);
        frame.openWindow(
            $WinDefs.winDef[this.customStatWin || Object.values($WinDefs.constructor.startWindow)[0]]
        );
        await new Promise(resolve => setTimeout(resolve, 500)).then(() => {
            this.sw.ItemSubscription.AddWindows(this._windows);
            this._windows = [];
        });
    }
}